import React from 'react';
import AppScreeningLog from './components';
import Layout from '../../layouts/index';

const ScreeningLog = () => {
    return (
        <Layout>
            <AppScreeningLog />
        </Layout>
    );
};

export default ScreeningLog;
